import React, { useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import queryString from "query-string";
import { Helmet } from "react-helmet";
import "./AllTaxiYad2ForSalepage.css";

import AllYad2TaxiForSalelist from "../../components/AllYad2TaxiForSalelist/AllYad2TaxiForSalelist";
import InsuranceSummaryHomepage from "../../components/InsuranceSummaryHomepage/InsuranceSummaryHomepage";
import BuyNewTaxiSiderHomePage from "../../components/BuyNewTaxiSiderHomePage/BuyNewTaxiSiderHomePage";
import Yad2ContactForm from '../../components/Yad2ContactForm/Yad2ContactForm';
import AdvancedTaxiFilter from '../../components/AdvancedTaxiFilter/AdvancedTaxiFilter';
import AdsAllTaxiYad2ForSalePage from './AdsAllTaxiYad2ForSalePage.png';
import { FaWhatsapp } from "react-icons/fa";

const AllTaxiYad2ForSalepage = () => {
  const location = useLocation();
  const { manufacturer } = queryString.parse(location.search);
  const [filters, setFilters] = useState({});

  return (
    <>
      <Helmet>
        <title>מוניות יד שנייה למכירה | BuyTaxi - קנה טקסי</title>
        <meta
          name="description"
          content="רוצה לקנות מונית יד שנייה? באתר BuyTaxi תמצא מגוון ענק של מוניות למכירה – מוניות פרטיות, היברידיות, מסחריות וזכויות ציבוריות. עם ביטוח, מימון ואפשרות ליצירת קשר ישיר עם המוכר. קנה חכם – רק ב-BuyTaxi."
        />
        <meta
          name="keywords"
          content="מוניות למכירה, מונית יד שנייה, קניית מוניות, לוח מוניות, מונית היברידית, מונית חדשה, מונית פרטית, מונית מסחרית, מספר ציבורי למכירה, ליסינג מוניות, מוניות להשכרה, קניית מונית בישראל, מוניות לעסק, רכישת מונית, בדיקות מונית, לוח רכב ציבורי, BuyTaxi"
        />
        <link rel="canonical" href="https://buytaxi.co.il/AllTaxiYad2ForSalepage" />
        <meta property="og:title" content="מוניות יד שנייה למכירה | BuyTaxi - קנה טקסי" />
        <meta
          property="og:description"
          content="לוח המוניות של ישראל – BuyTaxi! מוניות יד שנייה למכירה, מוניות היברידיות ודיזל, מספרים ציבוריים, ביטוח ומימון – הכול במקום אחד."
        />
        <meta property="og:image" content="https://buytaxi.co.il/public/og-image.jpg" />
        <meta property="og:url" content="https://buytaxi.co.il/AllTaxiYad2ForSalepage" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="מוניות יד שנייה למכירה | BuyTaxi" />
        <meta
          name="twitter:description"
          content="מצא את המונית שלך באתר BuyTaxi – מוניות יד שנייה, היברידיות, מספרים ציבוריים וכל השירותים שאתה צריך. קל, מהיר ואמין."
        />
        <meta name="twitter:image" content="https://buytaxi.co.il/public/og-image.jpg" />
        <meta name="twitter:site" content="@buytaxi" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "ItemList",
              "name": "מוניות יד שנייה למכירה",
              "image": "https://buytaxi.co.il/public/og-image.jpg",
              "description": "BuyTaxi – לוח המוניות המוביל בישראל. מוניות למכירה – יד שנייה, היברידיות, מספרים ציבוריים ועוד. קנייה בטוחה, מהירה, עם גישה ישירה למוכרים.",
              "brand": {
                "@type": "Organization",
                "name": "BuyTaxi"
              },
              "url": "https://buytaxi.co.il/AllTaxiYad2ForSalepage"
            }
          `}
        </script>
      </Helmet>

      <div className="AllTaxiYad2ForSalePage-container">
        <Link
          to="/products"
          onClick={() => {
            if (window.gtag) {
              window.gtag('event', 'AdsAllTaxiYad2ForSalePage', {
                event_category: 'HomepageAds',
                event_label: 'Click on mobile banner ad',
              });
            }
          }}
          className="AdsAllTaxiYad2ForSalePage"
        >
          <img
            src={AdsAllTaxiYad2ForSalePage}
            alt="באנר פרסום"
            className="MobileBannerAdImage"
          />
        </Link>

        <AdvancedTaxiFilter onFilterChange={(filters) => setFilters(filters)} />

        <div className="AllTaxiYad2ForSalePage-contect">
          <h3 className="AllTaxiYad2ForSalePage-listh3">מוניות למכירה</h3>

          <div className="AllTaxiYad2ForSalePage-list">
            <AllYad2TaxiForSalelist
              manufacturer={filters.manufacturer || manufacturer}
              minKm={filters.minKm}
              maxKm={filters.maxKm}
              minPrice={filters.minPrice}
              maxPrice={filters.maxPrice}
              showWithoutPrice={filters.showWithoutPrice}
              limitStart={0}
              limitCount={5}
            />
          </div>
        </div>

        <div className='FreePublishSendWhatsappYad2AllTaxiPage'>
          <a
            href="https://wa.me/972502268395?text=היי%20מעוניין%20לפרסם%20מונית%20למכירה%20בקנה%20טקסי"
            target="_blank"
            rel="noopener noreferrer"
            className="FreePublishSendWhatsappYad2AllTaxiPage-link"
          >
            <div className="FreePublishSendWhatsappYad2AllTaxiPage-header">
              <h2 className='FreePublishSendWhatsappYad2AllTaxiPageh2'>פרסם בחינם</h2>
              <div className="FreePublishSendWhatsappYad2AllTaxiPage-button">
                <FaWhatsapp className="whatsapp-icon" />
              </div>
            </div>
            <p className="FreePublishSendWhatsappYad2AllTaxiPage-subtext">
              שלחו את הפרטים בוואטספ והופ זה באוויר
            </p>
          </a>
        </div>

        {/* שאר הרשימות - עם אותם פילטרים */}
        {[5, 7, 12, 15, 25].map((start, i) => (
          <div key={i} className="AllTaxiYad2ForSalePage-list">
            <AllYad2TaxiForSalelist
              manufacturer={filters.manufacturer || manufacturer}
              minKm={filters.minKm}
              maxKm={filters.maxKm}
              minPrice={filters.minPrice}
              maxPrice={filters.maxPrice}
              showWithoutPrice={filters.showWithoutPrice}
              limitStart={start}
              limitCount={i === 0 ? 2 : 5}
            />
          </div>
        ))}

        <div className='AllTaxiYad2ForSalePage-form'>
          <Yad2ContactForm />
        </div>

        <div className="InsuranceSummaryHomepage-wrapper">
          <InsuranceSummaryHomepage />
        </div>

        <div className="BuyNewTaxiSiderHomePage-wrapper">
          <BuyNewTaxiSiderHomePage />
        </div>
      </div>
    </>
  );
};

export default AllTaxiYad2ForSalepage;
